module.exports = __webpack_public_path__ + "static/dskl-c31c65949946987ec4e4e6f64e72b53f.png";